<template>
  <card card-body-classes="table-full-width">
    <div slot="header" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <h4 slot="header" class="card-title">{{ $t('accountAuditLogs.tableTitle') }}</h4>
    </div>
    <audit-log-table :account-audit-logs="true" />
  </card>
</template>

<script>
import AuditLogTable from "@/components/AuditLog/AuditLogTable";

export default {
  name: 'account-audit-logs',
  components: {AuditLogTable},
};
</script>
